import { NavTabs } from "src/components/ui/NavTabs";

import { useAppState } from "src/state";

export function SuperAdminTenantTabs() {

    const { currentItemId } = useAppState(state=>state.tenants)

    return ( 
        <NavTabs
            parentId={currentItemId}
            urlRoot='/tenants'
            tabs={{
                details: {
                    label: 'Overview',
                    icon: 'home',
                    route: ''
                },
                users: {
                    label: 'Users',
                    icon: 'agents',
                    route: 'users'
                }
            }}
        />
    )

}